<template>
  <div class="articles">
    <div class="container">
      <div class="container__liner">
        <div id="navigation">
          <div class="breadcrumbs">
            <a itemprop="itemListElement" href="/" class="breadcrumbs-item">Главная</a>
            <span class="breadcrumbs-item">{{ actionsPage?'Акции':'Новости и статьи' }}</span>
          </div>
        </div>
        <div class="title">
          <h1 id="pagetitle">
            <span>{{ pageH1 }}</span>
          </h1>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="container__liner container__pd-bm">
        <div class="filtration">

          <div class="filtration__primary" v-if="!actionsPage">
            <label class="custom-ui custom-ui_solid">
              <input
                  type="radio"
                  class="custom-ui__input"
                  :checked="!type"
              />
              <span class="custom-ui__text" @click="setFilterType()">
                Все
              </span>
            </label>

            <label
                class="custom-ui custom-ui_solid"
                v-for="item in types"
                :key="item.id"
            >
              <input
                  type="radio"
                  class="custom-ui__input"
                  :checked="type === item.id"
              />
              <span class="custom-ui__text" @click="setFilterType(item.id)">
                {{ item.title }}
              </span>
            </label>
          </div>
          <div
              class="filtration__secondary"
              v-if="tags"
              :key="selectedTags.length"
          >
            <div class="filtration__explanation">
              Фильтрация по метками:
            </div>

            <label
                class="filtration__unit custom-ui custom-ui_elegant"
                :class="{'custom-ui-active': selectedTags.find(item => { return item.id === tag.id })}"
                v-for="(tag, index) in tags"
                :key="index"
                @click="setFilterTag(tag, $event)"
            >
              <span class="custom-ui__text">
                {{ tag.title }}
              </span>
            </label>
          </div>
        </div>

        <div v-if="loading" class="loader">
          <div class="box box-flex">
            <div class="item load-skeleton" style="height: 390px"></div>
            <div class="item item-flex" style="height: 250px">
              <div class="item item-full item-col-2 load-skeleton"></div>
              <div class="item item-full item-col-2 load-skeleton"></div>
            </div>
          </div>
        </div>

        <div v-else-if="data" class="knowledge knowledge_has-leader">
          <div class="knowledge__items">

            <div v-if="!data.length" class="knowledge__empty">
              {{ actionsPage?'Акции не найдены':'Статьи не найдены' }}
            </div>

            <div
                class="knowledge__item"
                v-for="(item, index) in data"
                :key="index"
            >
              <a :href="`${href}/${item.id}`" class="knowledge__unit clearfix">
                <div class="knowledge__ref">
                  <img :src="getImage('news', item.filename)" :alt="item.filename"/>
                </div>
                <div class="knowledge__content">
                  <div class="knowledge__date">
                    {{ formatDate(item.date) }}
                  </div>
                  <div class="knowledge__header">
                    {{ item.title }}
                  </div>
                  <div class="knowledge__text" v-html="item.text"></div>
                </div>
                <div class="knowledge__tags" v-if="item.tags.length">
                  <label
                      v-for="(tag, ind) in item.tags"
                      :key="ind"
                      class="knowledge__tag inviting"
                      @click="setFilterTag(tag, $event)"
                  >
                    {{ tag.title }}
                  </label>
                </div>
              </a>
            </div>
          </div>

          <pagination
              v-if="count > data.length"
              :currentPage="page"
              :countItems="count"
              :limitItems="limit"
              @switchPage="page = $event.page"
          />

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '../components/Pagination'
import { fetchNewsFilters, fetchNewsList, mediaUrl } from '../api/adminBrands'
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'

export default {
  components: {
    Pagination
  },
  data() {
    return {
      loading: null,
      tags: null,
      types: [],
      type: null,
      selectedTags: [],
      limit: 5,
      page: 1,
      data: null,
      count: null
    }
  },
  computed: {
    actionsPage() {
      if (this.$route.name === 'actions') return true
      return false
    },
    href() {
      if(this.$route.path.includes('articles')) return '/articles'
      else if(this.$route.path.includes('actions')) return '/actions'
      return '/'
    },
    pageH1() {
      if (!this.actionsPage && this.type) {
        const selected = (this.types || []).find((item) => String(item.id) === String(this.type))
        const title = selected && selected.title ? String(selected.title).trim() : ''
        if (title) return title
      }
      const s = this.$store.state.seoPage
      if (s && s.h1 && String(s.h1).trim()) {
        return String(s.h1).trim()
      }
      return this.actionsPage ? 'Акции' : 'Новости и статьи'
    },
  },
  methods: {
    async getDataArticles() {
      this.loading = true
      try {
        const response = await fetchNewsList({
          type: this.type,
          tags: this.selectedTags,
          page: this.page,
          limit: this.limit,
          excludeBanner: !this.actionsPage,
        })
        this.data = response.data
        this.count = response.count
      } catch (e) {
        this.data = []
        this.count = 0
      }
      setTimeout(() => this.loading = false, 450);
    },
    async getInitDataTags() {
      try {
        const response = await fetchNewsFilters({ type: this.type || undefined })
        this.types = response.types || []
        this.tags = response.tags || []

        if (this.actionsPage && !this.type) {
          const actionType = this.types.find((item) => /акци/i.test(item.title || item.id))
          if (actionType) this.type = actionType.id
        }

        if (this.$route.query.tag && this.tags) {
          const id = String(this.$route.query.tag)
          this.selectedTags = this.tags.filter((item) => String(item.id) === id)
        }
      } catch (e) {
        this.types = []
        this.tags = []
      }
    },
    setFilterTag(tag, event) {
      event.preventDefault()
      let tags = this.selectedTags
      let len = tags.length

      tags = tags.filter((item) => {
        return item.id !== tag.id
      })

      if (len === tags.length) tags.push(tag)
      this.selectedTags = tags
      this.page = 1
      this.getDataArticles()
    },
    async setFilterType(type = null) {
      this.type = type
      this.page = 1
      this.selectedTags = []
      await this.getInitDataTags()
      await this.getDataArticles()
    },
    getImage(type, name) {
      return mediaUrl(name)
    },
    formatDate(data) {
      const raw = data && data.date ? data.date : data
      if (!raw) return ''
      return this.$moment(raw).format('DD MMMM YYYY')
    }
  },
  watch: {
    page() {
      this.getDataArticles()
    }
  },
  async beforeMount() {
    if (this.$route.query.type) {
      const queryType = String(this.$route.query.type)
      if (queryType === '3' || /акци/i.test(queryType)) this.$router.push('/actions')
      this.type = queryType
    }
    await this.getInitDataTags()
    await this.getDataArticles()
  },
  metaInfo() {
    const title = this.actionsPage ? 'Акции' : 'Новости и статьи'
    return metaFromSeoOrDefaults(this.$store, { title })
  },
}

</script>
